import type { FollowNotification } from '@/@types/notification'
import UserCheckOutlineIcon from '@/assets/user-check-outline.svg?react'
import ClickableStackAvatarGroup from '@/components/ClickableStackAvatarGroup'
import ScreenNames from '@/components/ScreenNames'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'
import styles from './UserFollowNotification.module.css'

export interface UserFollowNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: FollowNotification
}

export default function UserFollowNotification({
	data,
	className,
	...props
}: UserFollowNotificationProps) {
	const {
		actionItem: { users, usersCount },
		referenceItem,
		createdAt,
	} = data
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<div className={styles.content}>
				<header className={styles.header}>
					<UserCheckOutlineIcon className={styles.icon} />
					<div className={styles.headerText}>
						<ScreenNames data={users.slice(0, 3)} className={styles.screenNames} />
						<span className={styles.secondaryText}>
							{usersCount > 3 && <span>等{usersCount}人</span>}
							关注了你
						</span>
					</div>
				</header>

				<main>
					<ClickableStackAvatarGroup data={users} className={styles.avatarGroup} />
				</main>
				<footer className={styles.footer}>{formatAsRelativeTime(createdAt)}</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
